<ng-container *transloco="let t; read: 'rename-analysis-group'">
  <div class="xi-modal__container">
    <h2 class="xi-modal__title kxi-text-600 kxi-text-large">{{ t('rename-analysis-group') }}</h2>

    <div class="xi-modal__content">
      <div class="rename-analysis-group__input-wrapper">
        <xi-input-field
          [label]="t('analysis-group-name')"
          [placeholder]="t('enter-here')"
          name="displayName"
          [(ngModel)]="displayName"
          required
          [status]="groupNameStatus"
          [prePopulateStatus]="true"
          (onChange)="onValidateAnalysisGroupName()"
          [stretch]="true"
        ></xi-input-field>
      </div>
    </div>

    <div class="xi-modal__actions">
      <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

      <xi-default-button
        [text]="t('save')"
        [disabled]="analysisGroupNameHasErrors()"
        (onClick)="saveGroupName()"
      ></xi-default-button>
    </div>
  </div>
</ng-container>
